import React from 'react';
import { useStyles } from '../styles/Styles';
import TextField from '@material-ui/core/TextField';

function ErrorAwareTimePicker(props) {
    const classes = useStyles(props, "text")();

    const { prevValue, ...rest } = props;

    return (
        <form className={classes.container} noValidate>
            <TextField
                fullWidth
                id="time"
                type="time"
                variant="outlined"
                className={classes.root}
                autoComplete="off"
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    step: 300, // 5 min
                }}
                {...rest}
            />
        </form>
    );
};
export default ErrorAwareTimePicker;